import type { CSSProperties } from "react";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

import { WFPButton } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

export { isItemActive, SidebarNavItem } from "./SidebarNavItem";
export { SidebarUserMenu } from "./SidebarUserMenu";
export type { SidebarNavigationItem } from "./types";

export const sidebarStyle = {
  "--sidebar-width": "17rem",
  "--sidebar-width-icon": "4.5rem",
  "--sidebar": "var(--background)",
} as CSSProperties;

export const SidebarToggle = () => {
  const { t } = useTranslation();
  const { open, toggleSidebar } = useSidebar();

  return (
    <WFPButton
      size="icon"
      aria-label={t("header.toggleSidebar")}
      aria-expanded={open}
      onClick={toggleSidebar}
      className="-right-6 -translate-y-1/2 absolute top-1/2 h-16 w-6 rounded-l-none"
    >
      <ChevronLeft className={cn("transition-transform duration-200", !open && "rotate-180")} />
    </WFPButton>
  );
};
